// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Modal_pageHolder__4Bu2D","modal":"Modal_modal__17FrW","closeButton":"Modal_closeButton__3QA_t","modalContent":"Modal_modalContent__lJOtA"};